export default "__VITE_ASSET__40yg88MH__"